import React from "react";
import { useTranslation } from "react-i18next";
import clientIcon from "../../../static/assets/Client.svg";
import assignmentIcon from "../../../static/assets/Assignment.svg";
import weightIcon from "../../../static/assets/Weight.svg";
import trashIcon from "../../../static/assets/Trash.svg";
import { apiWeightToTonnes } from "../core/utils/utils";

const InfoCardGrid = ({ data }) => {
  const { t } = useTranslation();
  const toSentenceCase = (value) => {
    if (!value) return value;
    const trimmed = value.trim();
    if (!trimmed) return trimmed;
    const lower = trimmed.toLowerCase();
    return `${lower.charAt(0).toUpperCase()}${lower.slice(1)}`;
  };

  // Format: "NAME (uniqueId), Address" — uniqueId from settings Client.clientUniqueId
  const formatClientDisplay = () => {
    const rawName = String(data?.clientParsed?.name || "").trim();
    if (!rawName || rawName === "-") return "-";
    const uniqueId = String(data?.clientParsed?.clientUniqueId || "").trim();
    const namePart = uniqueId
      ? `${rawName.toUpperCase()} (${uniqueId})`
      : rawName.toUpperCase();
    const address = data?.clientParsed?.address;
    if (!address || address === "-") return namePart;
    return `${namePart}, ${toSentenceCase(address)}`;
  };

  return (
    <div className="char-info-card-grid">
      <div className="char-info-card min-w-0">
        <div className="char-info-card-header">
          <img src={clientIcon} alt="client" className="char-info-card-icon" />
          <span className="char-info-card-label">{t("Waste origin")}</span>
        </div>
        <div className="char-info-card-value flex items-center gap-2 min-w-0">
          <span className="block min-w-0 max-w-[90%] truncate">
            {formatClientDisplay()}
          </span>
          {data?.clientSource === "legacy" && (
            <span
              className="shrink-0 cursor-help text-gray-500"
              title={t(
                "Legacy waste origin: data not linked to a unique record",
              )}
              aria-label={t(
                "Legacy waste origin: data not linked to a unique record",
              )}
            >
              <i className="fa fa-info-circle text-sm" aria-hidden />
            </span>
          )}
        </div>
      </div>
      <div className="char-info-card min-w-0">
        <div className="char-info-card-header">
          <img
            src={assignmentIcon}
            alt="assignment"
            className="char-info-card-icon"
          />
          <span className="char-info-card-label">
            {t("Identification reference of the characterization")}
          </span>
        </div>
        <div className="char-info-card-value">
          {data?.clientParsed?.code || "-"}
        </div>
      </div>
      <div className="char-info-card min-w-0">
        <div className="char-info-card-header">
          <img src={weightIcon} alt="weight" className="char-info-card-icon" />
          <span className="char-info-card-label">{t("Weight")}</span>
        </div>
        <div className="char-info-card-value">
          {data?.weight != null
            ? `${(apiWeightToTonnes(data.weight) ?? 0).toLocaleString("fr-FR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })} ${t("tons")}`
            : "-"}
        </div>
      </div>
      <div className="char-info-card min-w-0">
        <div className="char-info-card-header">
          <img src={trashIcon} alt="trash" className="char-info-card-icon" />
          <span className="char-info-card-label">{t("Waste name")}</span>
        </div>
        <div className="char-info-card-value">
          {data?.wasteCategory ? data.wasteCategory.wasteCategoryName : "-"}
        </div>
      </div>
    </div>
  );
};
export default InfoCardGrid;
